import React, {useEffect, useRef} from 'react';

import styles from './Datapoint.module.scss';

import { motion, useAnimation, useInView } from 'framer-motion';

const Datapoint = ({title, description, image, imageWidth = undefined, video, position = "left", className = "", paralel = undefined, direction = 'vertical'}) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    const mainControls = useAnimation();

    useEffect(() => {
        if (isInView) {
            mainControls.start("visible");
        }
    }, [isInView]);

    const isHorizontal = direction === 'horizontal';

    return (
        <div ref={ref} className={`${styles.container} ${styles[position]} ${className} ${styles[direction]}`}>
            {title || description ? <motion.div
                className={styles.contentContainer}
                variants={{
                    hidden: { opacity: 0, x: position === 'center' || isHorizontal ? 0 : position === 'left' ? -75 : 75, y: isHorizontal ? 75 : 0 },
                    visible: { opacity: 1, x: 0, y: 0 }
                }}
                initial="hidden"
                animate={mainControls}
                transition={{duration: 0.5}}
            >
                <h3>{title}</h3>
                <p>{description}</p>
            </motion.div> : undefined}
            <div className={styles.lineContainer}>
                <div className={styles.line} />
                <div className={styles.dot} />
            </div>
            <motion.div
                className={styles.imageContainer}
                variants={{
                    hidden: {
                        opacity: 0,
                        x: position === 'center' || isHorizontal ? 0 : position === 'left' ? 75 : -75,
                        y: isHorizontal ? -75 : 0
                    },
                    visible: { opacity: 1, x: 0, y: 0 }
                }}
                initial="hidden"
                animate={mainControls}
                transition={{duration: 0.5}}
            >
                {image ? <img alt="Datapoint image" src={image} width={imageWidth} /> : undefined}
                {video ? <video controls autoPlay loop muted width="100%">
                    <source src={video} type="video/mp4"></source>
                </video> : undefined}
                <div className={styles.imageBorder} />
            </motion.div>
        </div>
    )
}

export default Datapoint;